import state from "./state.js";
import * as getters from "./getters.js";
import * as mutations from "./mutations.js";
import * as rawActions from "./actions.js";
import onlyActions from "../onlyActions.js";

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: onlyActions(rawActions),
};
